import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  AccessControlListService,
  UserGroupAcl,
  UserGroupAclGroups,
  UserGroupAclMembers,
} from '@rocksoft/security-sdk';
import { map, mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import {
  AccessControlListApiActions,
  GroupAclPermissionsUiActions,
  SettingPermissionsResolverActions,
  UserAclPermissionsUiActions,
} from './user-group-acl.actions';

@Injectable()
export class UserGroupAclEffects {
  private readonly accessControlListService = inject(AccessControlListService);
  private readonly actions$ = inject(Actions);

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SettingPermissionsResolverActions.userGroupAclRequested),
      mergeMap(({ resourceId }) =>
        safeMap(
          this.accessControlListService.getUserGroupAcl({ resourceId }),
          (userGroupAcl: UserGroupAcl) => AccessControlListApiActions.userGroupAclLoaded({ userGroupAcl }),
          (error) => AccessControlListApiActions.userGroupAclLoadedError({ error })
        )
      )
    );
  });

  userGroupAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserAclPermissionsUiActions.userGroupAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.accessControlListService
          .putUserGroupAclMembers({ userGroupAclMembers: aclMember })
          .pipe(
            map((userGroupAclMember: UserGroupAclMembers) =>
              AccessControlListApiActions.userGroupAclMemberPut({ aclMember: userGroupAclMember })
            )
          )
      )
    );
  });

  userGroupAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupAclPermissionsUiActions.userGroupAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.accessControlListService
          .putUserGroupAclGroups({ userGroupAclGroups: aclGroup })
          .pipe(
            map((userGroupAclGroup: UserGroupAclGroups) =>
              AccessControlListApiActions.userGroupAclGroupPut({ aclGroup: userGroupAclGroup })
            )
          )
      )
    );
  });
}
